import React, { PropsWithChildren } from "react";
import Grid from "@mui/material/Grid2";

import { IconButton, Tooltip } from "@mui/material";

import { useTranslation } from "react-i18next";
import { Add, Replay } from "@mui/icons-material";
import ToolButtonsContainer from "@common/components/ToolButtonsContainer";

export type FilteringBarProps = {
  refetch: () => void;
  deleteButton?: React.JSX.Element;
  onOpenAdd?: () => void;
  disableAddButton?: boolean;
  loading?: boolean;
  generateBillingButton?: React.JSX.Element;
};

const FilteringBar = (props: PropsWithChildren<FilteringBarProps>) => {
  const {
    refetch,
    onOpenAdd,
    disableAddButton = false,
    deleteButton,
    generateBillingButton,
  } = props;

  const { t } = useTranslation();

  const handleClickRefresh = () => {
    refetch();
  };
  return (
    <>
      <Grid
        container
        direction="row"
        wrap="nowrap"
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          width: "auto",
          flexGrow: 1,
          position: "sticky",
          right: 0,
          pr: 2,
        }}
      >
        <Grid
          container
          wrap="nowrap"
          spacing={1.25}
          sx={{
            width: "100%",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {deleteButton && <Grid>{deleteButton}</Grid>}
          {onOpenAdd !== undefined && (
            <ToolButtonsContainer>
              <Tooltip title={t("Add") as string} arrow>
                <span>
                  <IconButton
                    size="small"
                    onClick={onOpenAdd}
                    disabled={disableAddButton}
                  >
                    <Add />
                  </IconButton>
                </span>
              </Tooltip>
            </ToolButtonsContainer>
          )}

          {generateBillingButton && <Grid>{generateBillingButton}</Grid>}

          <ToolButtonsContainer>
            <Tooltip title={t("Refresh") as string} arrow>
              <span>
                <IconButton size="small" onClick={handleClickRefresh}>
                  <Replay />
                </IconButton>
              </span>
            </Tooltip>
          </ToolButtonsContainer>
        </Grid>
      </Grid>
    </>
  );
};

export default FilteringBar;
